/* eslint-disable react-hooks/exhaustive-deps */
import { isFunction } from "lodash-es";
import React, { useCallback } from "react";
import { classnames } from "../../utils/text";

const getStyle = (color = "blue") => {
  return color.toLowerCase();
};

const ToggleSwitch = ({
  label,
  color, //blue, green, red, orange
  disabled = false,
  checked = false,
  onChange,
  name,
  data,
  className,
}) => {
  const getChecked = useCallback(() => {
    return isFunction(checked) ? checked(data) : checked;
  }, [checked]);

  return (
    <div className={classnames(`switch-component-wrap ${className}`, {
      disabled
    })}>
      <label className="switch-label">{label}</label>
      <label className="switch-component">
        <input
          type="checkbox"
          name={name}
          className={`switch-${getStyle(color)}`}
          disabled={disabled}
          checked={getChecked()}
          onChange={(e) => {
            onChange(e, data);
          }}
        />
        <span className="slider round" />
      </label>
    </div>
  );
};

export default ToggleSwitch;
